module.exports = __webpack_public_path__ + "static/media/iconError.736a641a.svg";